import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const StatusBadge = ({ textColor, bgColor, dotColor, label }) => {
  return (
    <p
      className={clsx(
        'flex w-max items-center gap-1.5 rounded-[50px] px-3 py-0.5 text-[11px] font-semibold',
        bgColor,
        textColor
      )}
    >
      <span className={clsx('block h-1.5 w-1.5 rounded-full', dotColor)} />
      <span>{label}</span>
    </p>
  );
};

export default function EmployeeStatus({ status }) {
  const { t } = useTranslation('forms');

  if (!status) return null;

  const action = (typeof status === 'object' && status?.key)
    ? status.key.toLowerCase()
    : (typeof status === 'string' ? status.toLowerCase() : null);
  const allowedStatus = ['active', 'suspended', 'locked'];

  switch (action) {
    case 'active':
      return (
        <StatusBadge
          textColor="text-green-700"
          bgColor="bg-green-100"
          dotColor="bg-green-500"
          label={t(action)}
        />
      );
    case 'locked':
      return (
        <StatusBadge
          textColor="text-orange-700"
          bgColor="bg-orange-100"
          dotColor="bg-orange-500"
          label={t(action)}
        />
      );
    case 'suspended':
      return (
        <StatusBadge
          textColor="text-zinc-700"
          bgColor="bg-zinc-100"
          dotColor="bg-zinc-500"
          label={t(action)}
        />
      );
    default:
      if (allowedStatus.includes(status)) {
        console.warn('This status is not supported', status);
      }
      return null;
  }
}
